import React from 'react'
import Loader from 'react-loader-spinner'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import './button.scss'

const Button = ({
  text,
  loading = false,
  className = '',
  onClick = evt => {},
  type = 'button',
  disabled = false,
  metric = null,
}) => {
  return (
    <button
      className={`f-button-magic-box ${className}`}
      onClick={e => {
        if (disabled) {
          return
        }
        if (metric) {
          pushEventData({ ...metric, label: text })
        }
        onClick(e)
      }}
      type={type}
    >
      {loading ? (
        <Loader type="Oval" color="#ffffff" height={22} width={30} />
      ) : (
        text
      )}
    </button>
  )
}

export default Button
